/**
 * 过滤字符串中的 emoji 和特殊字符
 * @param str 原始字符串
 * @returns 过滤后的字符串
 */
export function filterEmoji(str: string): string {
  if (!str) return '';

  // emoji 正则表达式，匹配各种 emoji 字符
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1F200}-\u{1F2FF}]/gu;

  // 其他特殊字符和符号
  const specialCharsRegex = /[\u{2000}-\u{206F}]|[\u{2E00}-\u{2E7F}]|[\u{3000}-\u{303F}]|[\u{FFF0}-\u{FFFF}]/gu;

  // 零宽字符
  const zeroWidthRegex = /[\u{200B}-\u{200D}]|[\u{FEFF}]/gu;

  return str
    .replace(emojiRegex, '') // 移除 emoji
    .replace(specialCharsRegex, '') // 移除特殊字符
    .replace(zeroWidthRegex, '') // 移除零宽字符
    .trim(); // 移除首尾空格
}
